<!--
 * @Author: your name
 * @Date: 2019-06-18 11:07:26
 * @LastEditTime: 2020-01-12 08:28:37
 * @LastEditors: your name
 * @Description: In User Settings Edit
 * @FilePath: /Apphi-Post-Web/src/components/common/button/Remove.vue
 -->
<template>
  <el-popover
    placement="bottom"
    width="248"
    v-model="removeModal"
    trigger="click"
  >
    <div class="remove-container">
      <div class="message">
        All schedules on this social account will not auto post after your
        remove it. Confirm remove?
      </div>
      <div class="btn-group">
        <div class="btn" @click="removeModal = false">Cancel</div>
        <div class="btn" @click="removeClick(item)">Yes</div>
      </div>
    </div>
    <div slot="reference">
      <div class="remove-btn">Remove</div>
    </div>
  </el-popover>
</template>

<style lang="less" scoped>
@import "../../../assets/style/theme.less";
.remove-btn {
  text-align: right;
  font-size: 15px;
  cursor: pointer;
  &:active,
  &:hover {
    opacity: 0.8;
  }
}
.remove-container {
  height: 190px;
  padding: 30px;
  width: auto;
  .message {
    font-size: 14px;
    text-align: center;
    width: 100%;
  }
  .btn-group {
    display: flex;
    margin-top: 25px;
    justify-content: space-between;
    .btn {
      width: 88px;
      height: 28px;
      background-color: #e72955;
      border-radius: 2px;
      font-size: 14px;
      color: #ffffff;
      display: flex;
      align-items: center;
      justify-content: center;
      cursor: pointer;
      &:active,
      &:hover {
        opacity: 0.8;
      }
    }
  }
}
</style>

<script>
export default {
  name: "RemoveButtonComponent",
  data() {
    return {
      removeModal: false,
    };
  },
  methods: {
    removeClick() {
      this.removeModal = false;
      this.$emit("click", this.item);
    },
  },
};
</script>
